import React from 'react'
import { useEffect } from 'react'
import Navigation from '../../../components/Navigation/Navigation'
import styles from './Home.module.css'
import axios from 'axios';
import { API } from '../../../config/API';
import Loader from '../../../components/Loader/Loader';

export default function Home() {
const [tenantList, setTenantList] = React.useState([]); // State to hold tenant data
const [loading, setLoading] = React.useState(false); // State to manage loading state

useEffect(() => {
     getTenantList()
}, [])

const getTenantList = async () => {
    try {
        const response = await axios.get(API.getTenantDetail); 
        if(response.status == 200 && response?.data?.status == 'S') {
           setTenantList(response.data.data);
        }
       
        console.log('Tenant List:', response.data.data);
    } catch (error) {
        console.error('Error fetching tenant list:', error);
    }
  }
  
  const handleApprove = async (tenantRequestId) => {
    setLoading(true);
    try {
      const payload = {
        tenantRequestId: tenantRequestId,
        approve: true,
        comments: "ok"
      };
      const response = await axios.post(API.approveSignup, payload);
      setLoading(false);
      if (response.status === 200 && response.data.status === 'S') {
        // Optionally refresh the tenant list or show a success message
       alert(response.data.message);
      } else {
        console.error('Approval failed:', response.data);
      }
    } catch (error) {
      setLoading(false);
      console.error('Error approving tenant:', error);
    }
  }
    
  return (
    <div>
      <Loader loading={loading} />
        <header>
            <Navigation />
        </header>
        <div className={styles.homeContent}>
            <h1>Platform Admin Home</h1>
            <p>Welcome to the Platform Admin Dashboard.</p>
            <p>Here you can manage platform-wide settings and configurations.</p> 
            <table style={{width: '90%', margin: '24px auto 0 auto', borderCollapse: 'collapse', background: '#fff'}}>
              <thead>
                <tr>
                  <th style={{border: '1px solid #ccc', padding: 8}}>Email</th>
                  <th style={{border: '1px solid #ccc', padding: 8}}>Name</th>
                  <th style={{border: '1px solid #ccc', padding: 8}}>Status</th>
                  <th style={{border: '1px solid #ccc', padding: 8}}>Tenant Request ID</th>
                  <th style={{border: '1px solid #ccc', padding: 8}}>Action</th>
                </tr>
              </thead>
              <tbody>
                {tenantList && tenantList.length > 0 ? tenantList.map((tenant, idx) => (
                  <tr key={tenant.tenantRequestId || idx}>
                    <td style={{border: '1px solid #ccc', padding: 8}}>{tenant.email}</td>
                    <td style={{border: '1px solid #ccc', padding: 8}}>{tenant.name}</td>
                    <td style={{border: '1px solid #ccc', padding: 8}}>{tenant.status}</td>
                    <td style={{border: '1px solid #ccc', padding: 8}}>{tenant.tenantRequestId}</td>
                    <td style={{border: '1px solid #ccc', padding: 8}}>
                      <button onClick={() => handleApprove(tenant.tenantRequestId)} style={{padding: '4px 12px'}}>Approve</button>
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan={5} style={{textAlign: 'center', padding: 16}}>No tenants found.</td></tr>
                )}
              </tbody>
            </table>
        </div>
    </div>
  )
}
